// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"Pricing_col-md-4__Fg1mr","aBlockTitle":"Pricing_aBlockTitle__OGSX5","aTitle":"Pricing_aTitle__xKiuA","oPricingSectionBlock":"Pricing_oPricingSectionBlock__1Enye"};